import { post as $post } from './core/fetch';


export const _search = (search_params) => $post('/search', search_params);
